import { Extension } from '@tiptap/core'

export const TabKeyHandler = Extension.create({
  name: 'tabKeyHandler',

  addKeyboardShortcuts() {
    return {
      Tab: ({ editor }) => {
        if (editor.isActive('listItem')) {
          return editor.chain().sinkListItem('listItem').run()
        }
        if (editor.isActive('codeBlock')) {
          return editor.chain().insertContent('\t').run()
        }
        return false // let browser handle otherwise
      },
      'Shift-Tab': ({ editor }) => {
        if (editor.isActive('listItem')) {
          return editor.chain().liftListItem('listItem').run()
        }
        return false
      },
    }
  },
})
